import { action, Action } from 'typesafe-actions'

import { LastServiceResponse, SessionTypes } from './types'

export const setSessionId = (payload: string): Action =>
  action(SessionTypes.SET_SESSION_ID, payload)
export const setSessionCreateDate = (payload: string): Action =>
  action(SessionTypes.SET_SESSION_CREATE_DATE, payload)
export const setUtmSource = (payload: string): Action =>
  action(SessionTypes.SET_UTM_SOURCE, payload)
export const setUtmMedium = (payload: string): Action =>
  action(SessionTypes.SET_UTM_MEDIUM, payload)
export const setUtmContent = (payload: string): Action =>
  action(SessionTypes.SET_UTM_CONTENT, payload)
export const setUtmCampaign = (payload: string): Action =>
  action(SessionTypes.SET_UTM_CAMPAIGN, payload)
export const setFacebookId = (payload: string): Action =>
  action(SessionTypes.SET_FACEBOOK_ID, payload)
export const setGaClientId = (payload: string): Action =>
  action(SessionTypes.SET_GA_CLIENT_ID, payload)
export const setGaClid = (payload: string): Action => action(SessionTypes.SET_GA_CLID, payload)
export const setCpfSession = (payload: string | undefined): Action =>
  action(SessionTypes.SET_CPF_SESSION, payload)
export const setAccessToken = (payload: string | undefined): Action =>
  action(SessionTypes.SET_ACCESS_TOKEN, payload)
export const setUserNameSession = (payload: string): Action =>
  action(SessionTypes.SET_USER_NAME_SESSION, payload)
export const setCampanha = (payload: string): Action => action(SessionTypes.SET_CAMPANHA, payload)
export const setSangueLaranja = (payload: boolean): Action =>
  action(SessionTypes.SET_SANGUE_LARANJA, payload)
export const setLastServiceResponse = (payload: LastServiceResponse): Action =>
  action(SessionTypes.SET_LAST_SERVICE_RESPONSE, payload)
